import React from 'react';
import OrderLayout from '../../common/Order/OrderLayout';

const OrderDashboard = () => {
	return (
		<div>
			<OrderLayout />
		</div>
	);
};

export default OrderDashboard;
